<template>
  <div id="app" :class="{ expand: showSidebar }">
    <Sidebar :show="showSidebar" @toggle="showSidebar = !showSidebar" />
    <div class="main">
      <router-view/>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'

export default {
  components: {
    Sidebar,
  },
  data() {
    return {
      showSidebar: true,
    }
  },
}
</script>

<style lang="scss">
#app {
  height: 100%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: min-content 1fr;

  &.expand {
    grid-template-columns: 2fr 8fr;
  }
}

.main {
  grid-column: 2;
  grid-row: 1;
}
</style>
